export default {"src":"/_next/static/media/shape2.6bd6914d.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};